import {
  ADD_DISTRIBUTION_LIST_ROWS,
  CLEAR_REPOSITORY_CONFIGURATION,
  DELETE_DISTRIBUTION_LIST_ROW,
  SET_DISTRIBUTION_MODAL_OPEN,
  SET_REPOSITORY_DATA,
  SET_REPOSITORY_PROP_VALUE,
  UPDATE_ORIGINAL_REPOSITORY_PROP_VALUE,
  UPDATE_REPOSITORY_TREE,
} from '../actions/RepositoryConfigurationActions';
import { set } from '../utils/ramdaUtils';

export default function repositoryConfigurationReducer(state = {}, action) {
  switch (action.type) {
    case SET_REPOSITORY_DATA:
      return action.payload.repositoryData || {};

    case UPDATE_REPOSITORY_TREE: {
      const { newTree } = action.payload;

      return set(state, ['repositoryDetails', 'repositoryTree'], newTree);
    }

    case SET_DISTRIBUTION_MODAL_OPEN: {
      const { flag } = action.payload;

      return { ...state, isDistributionModalOpen: flag };
    }

    case SET_REPOSITORY_PROP_VALUE: {
      const { prop, value } = action.payload;

      const propPath = prop?.split('.') || [];

      return set(state, ['repositoryDetails', ...propPath], value);
    }

    case UPDATE_ORIGINAL_REPOSITORY_PROP_VALUE: {
      const { prop, value } = action.payload;

      const propPath = prop?.split('.') || [];

      return set(state, ['originalRepositoryDetails', ...propPath], value);
    }

    case ADD_DISTRIBUTION_LIST_ROWS: {
      const { newRows, distributionType } = action.payload;
      const currentDistributionList = state.repositoryDetails?.[distributionType].distributionList;

      return set(
        state,
        ['repositoryDetails', distributionType, 'distributionList'],
        [...newRows, ...currentDistributionList]
      );
    }

    case DELETE_DISTRIBUTION_LIST_ROW: {
      const { rowId, distributionType } = action.payload;

      const updatedRows = state.repositoryDetails[distributionType].distributionList.filter(
        (row) => row.rowId !== rowId
      );

      return set(state, ['repositoryDetails', distributionType, 'distributionList'], updatedRows);
    }

    case CLEAR_REPOSITORY_CONFIGURATION: {
      return {};
    }

    default:
      return state;
  }
}
